import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-stone-100 text-stone-600">
      <div className="px-6 lg:px-12 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://storage.readdy-site.link/project_files/e9818d6f-bba1-4e7d-b659-43a4cdb14da8/1ea3d842-56cd-4003-8ff3-01ce59ecb29a_GD-and-Assoc-logo-2.png?v=c43fa0a4468a2674f83bdbc3f0d450dd"
              alt="Glen Davis and Associates Photography"
              className="h-10 w-auto object-contain mb-4 mix-blend-multiply"
            />
            <p className="text-stone-500 text-sm leading-relaxed">
              Automotive photography and custom car show display boards based in Bremerton, WA. Serving Kitsap County and the greater Puget Sound region.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://www.facebook.com/media/set/?set=a.1213616161983207&type=3"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-200 text-stone-400 hover:border-gold hover:text-gold transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a
                href="https://www.instagram.com/glendavisrodshots/"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-200 text-stone-400 hover:border-gold hover:text-gold transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 id="footer-links" className="text-charcoal text-sm font-semibold uppercase tracking-widest mb-5">
              <a href="#footer-links">Quick Links</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: "Home", path: "/" },
                { label: "Services", path: "/services" },
                { label: "About Glen Davis", path: "/about" },
                { label: "Location & Service Areas", path: "/location" },
              ].map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-stone-500 text-sm hover:text-gold transition-colors cursor-pointer"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://www.legendaryportraits.com/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-stone-500 text-sm hover:text-gold transition-colors cursor-pointer"
                >
                  Legendary Portraits ↗
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 id="footer-contact" className="text-charcoal text-sm font-semibold uppercase tracking-widest mb-5">
              <a href="#footer-contact">Contact</a>
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <a
                  href="tel:360-204-4747"
                  className="text-stone-500 text-sm hover:text-gold transition-colors flex items-center gap-2 cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line text-gold"></i>
                  </div>
                  360-204-4747
                </a>
              </li>
              <li>
                <a
                  href="https://maps.app.goo.gl/fb7msCbj7DyRFWRr9"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-stone-500 text-sm hover:text-gold transition-colors flex items-start gap-2 cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                    <i className="ri-map-pin-line text-gold"></i>
                  </div>
                  709 Shore Dr.<br />Bremerton, WA
                </a>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 id="footer-areas" className="text-charcoal text-sm font-semibold uppercase tracking-widest mb-5">
              <a href="#footer-areas">Service Areas</a>
            </h4>
            <p className="text-stone-500 text-sm leading-relaxed">
              Bremerton · Silverdale · Port Orchard · Poulsbo · Bainbridge Island · Tacoma · Seattle · Kitsap County · Puget Sound Region
            </p>
          </div>
        </div>

        <div className="border-t border-stone-100 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-400 text-xs">
            &copy; {new Date().getFullYear()} Glen Davis and Associates Photography. All Rights Reserved. Bremerton, WA.
          </p>
          <p className="text-stone-400 text-xs">Design by Glen Davis</p>
        </div>
      </div>
    </footer>
  );
}
